export const INTRO_OFFER_PERCENT = 45;

export const formatCents = (cents) => `$${(cents / 100).toFixed(2)}`;

/**
 * How a discount is said: floored to a multiple of five, with a "+" when it
 * is a point or more above that ("45%+" for 46.7%, "20%" for 20.01%, "50%"
 * for 50%), so the words never overstate the deal. Empty when there is no
 * discount worth claiming.
 */
export const percentLabel = (pct) => {
  if (!Number.isFinite(pct) || pct <= 0) return '';
  const floored = Math.floor(pct / 5 + 1e-9) * 5;
  if (floored <= 0) return '';
  return pct - floored >= 1 ? `${floored}%+` : `${floored}%`;
};
export const discountLabel = (regularCents, discountedCents) => {
  if (!regularCents || !Number.isFinite(discountedCents) || discountedCents >= regularCents) return '';
  return percentLabel((1 - discountedCents / regularCents) * 100);
};

export const getIntroPricing = ({
  monthlyPrice,
  annualMonthlyPrice,
  billingPeriod,
  discountPercent = INTRO_OFFER_PERCENT,
  // An exact first-period price in cents (a fixed-amount coupon). When given
  // it replaces the percentage, which is then derived from it for display.
  firstPeriodCents,
  // The regular amount for this period in cents, when known exactly (the
  // funnel reads it from Stripe); otherwise it is derived from the prices.
  regularCents: regularCentsExact,
}) => {
  const isAnnual = billingPeriod === 'annual';
  const unitPrice = isAnnual ? annualMonthlyPrice : monthlyPrice;
  const regularCents = Number.isFinite(regularCentsExact) && regularCentsExact > 0
    ? Math.round(regularCentsExact)
    : Math.round(unitPrice * 100) * (isAnnual ? 12 : 1);
  const fixed = Number.isFinite(firstPeriodCents) && firstPeriodCents >= 0 && firstPeriodCents < regularCents;
  const discountedCents = fixed
    ? Math.round(firstPeriodCents)
    : Math.round(regularCents * ((100 - discountPercent) / 100));
  if (fixed) discountPercent = Math.round((1 - discountedCents / regularCents) * 100);

  return {
    discountPercent,
    regularCents,
    discountedCents,
    regularPrice: formatCents(regularCents),
    discountedPrice: formatCents(discountedCents),
    periodLabel: isAnnual ? 'first year' : 'first month',
    renewalPrice: `${formatCents(regularCents)}/${isAnnual ? 'year' : 'month'}`,
  };
};
